import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

export const Background = () => {
  const experiences = [
    {
      title: "Head of Growth",
      company: "Helios Conversions",
      description: "Architected growth systems delivering 5–30x ROAS across 10–15 clients spanning DTC, iGaming, and affiliate-driven funnels. Shifted team from reactive management to a predictive SOP-driven engine. Doubled client retention."
    },
    {
      title: "Brand + Performance Marketing",
      company: "JStar Berhad",
      description: "Co-managed $1.5M USD APAC ad spend across regulated and performance-heavy verticals. 5–10x ROAS sustained. Spearheaded GTM for enterprise SaaS via paid media and CRO."
    },
    {
      title: "Performance Marketing Specialist",
      company: "JStar Berhad",
      description: "Built expertise across high-friction verticals including affiliate traffic arbitrage and iGaming — environments where funnel efficiency isn't a nice-to-have, it's survival. Grew from execution to full strategy ownership."
    }
  ];

  const environments = [
    'iGaming & regulated markets',
    'Affiliate traffic arbitrage',
    'High-consideration purchases',
    'Enterprise SaaS GTM',
    'Finance & fintech funnels',
    'DTC e-commerce'
  ];

  const skills = [
    { name: 'Conversion architecture / CRO', level: 95 },
    { name: 'Paid media (Meta, Google, DV360, programmatic)', level: 92 },
    { name: 'Funnel diagnostics & analytics', level: 87 },
    { name: 'Revenue modeling / unit economics', level: 82 },
    { name: 'Team & cross-functional leadership', level: 78 }
  ];

  const tools = [
    'Meta Ads', 'Google Ads', 'TikTok Ads', 'DV360', 'Exoclick', 'Propeller Ads',
    'Convert', 'VWO', 'Growthbook', 'Hotjar', 'Mouseflow', 'GTM', 'Looker Studio',
    'Airtable', 'HubSpot', 'Miro', 'Webflow', 'Claude Cowork'
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#F5F5F5]">
      {/* Where I've Worked */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <h1 className="text-5xl font-bold mb-12">Where I've worked</h1>
        
        <div className="space-y-6">
          {experiences.map((exp, index) => (
            <Card key={index} className="bg-[#1a1a1a] border-none p-8 space-y-3">
              <div className="flex items-center gap-3">
                <h3 className="text-xl font-semibold text-[#F5F5F5]">{exp.title}</h3>
                <span className="text-[#888888]">·</span>
                <span className="text-[#E85D04]">{exp.company}</span>
              </div>
              <p className="text-[#888888] leading-relaxed">{exp.description}</p>
            </Card>
          ))}
        </div>
      </section>

      {/* Environments I've Worked In */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <h2 className="text-4xl font-bold mb-8">Environments I've worked in</h2>
        <p className="text-[#F5F5F5] text-lg leading-relaxed mb-8">
          DTC is straightforward compared to where I've sharpened this. I've optimised funnels in regulated iGaming markets where retargeting is restricted and compliance limits creative, and in high-level traffic arbitrage in affiliate marketing where margin is razor-thin and every funnel decision is a direct hit to profitability. When CAC is punishing and CVR has to do all the heavy lifting, you get very good at finding the leak fast.
        </p>
        <div className="flex flex-wrap gap-3">
          {environments.map((env) => (
            <Badge key={env} className="bg-[#E85D04] text-white hover:bg-[#E85D04]/90 px-4 py-2 text-sm">
              {env}
            </Badge>
          ))}
        </div>
      </section>

      {/* Depth by Discipline */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <h2 className="text-4xl font-bold mb-12">Depth by discipline</h2>
        <div className="space-y-8">
          {skills.map((skill) => (
            <div key={skill.name} className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-[#F5F5F5] text-lg">{skill.name}</span>
                <span className="text-[#E85D04] font-semibold">{skill.level}%</span>
              </div>
              <div className="h-2 bg-[#1a1a1a] rounded-full overflow-hidden">
                <div 
                  className="h-full bg-[#E85D04] transition-all duration-1000"
                  style={{ width: `${skill.level}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Tools */}
        <div className="mt-16">
          <div className="flex flex-wrap gap-2">
            {tools.map((tool) => (
              <Badge key={tool} variant="outline" className="bg-[#0a0a0a] border-[#888888] text-[#888888] px-3 py-1">
                {tool}
              </Badge>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};